
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"1spskj8ita","d":"M24 24H0V0h24v24z"}})]),_c('clipPath',{attrs:{"id":"pa7k2s8kkb"}},[_c('use',{attrs:{"xlink:href":"#1spskj8ita","overflow":"visible"}})]),_c('path',{attrs:{"clip-path":"url(#pa7k2s8kkb)","d":"M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"}})])
          )
        }
      }
    